<template>
  <PrintPackagesDatatable
      :print-packages="printPackages"
      :loading="loading"
      :total="total"
      @update="onUpdate"
  />
</template>

<script>
import PrintPackagesDatatable from "@/components/PrintPackagesDatatable"
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import PrintPackageService from "@/services/print.package.service";
import Moment from "moment";
import _ from "underscore";
import Mapper from "@/mappers"
import {AllowCreatePrintPackage} from "@/enums/permission";

export default {
  name: "PrintPackagesView",
  components: {
    PrintPackagesDatatable
  },
  data() {
    return {
      printPackages: [],
      total: 0,
      loading: false
    }
  },
  computed: {
    isAllowPrintPackagesListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePrintPackage
      })
    },
  },
  methods: {
    onUpdate(options, filters) {
      this.reloadPrintPackages(options, filters)
    },
    reloadPrintPackages(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {region, area, start, end} = filters;

      const skip = (page - 1) * itemsPerPage;

      PrintPackageService.getDatatable({
        skip: skip,
        limit: itemsPerPage,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        client: this.$store.getters.appActiveClient,
        region: region,
        area: area,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null
      })
          .then(response => {
            this.printPackages = _.map(response.data.Records, printPackageViewModel => {
              return Mapper.mapPrintPackage(printPackageViewModel)
            })

            this.total = response.data.Total;
          }, () => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowPrintPackagesListing) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Печатные реестры")
    } else {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>